import ConditionProperty from './ConditionProperty';
import ConditionVisibleControls from './ConditionVisibleControls';

type IndexProperty = {
  index: number;
  label: string;
};

export default class StructuredEventProperty extends ConditionProperty {
  static override readonly label: string = 'Structured event property';
  static override readonly formFields: ConditionVisibleControls  = { fieldName: false, fieldPath: false, fieldIndex: true };
  static override readonly type: number = 2;
  static readonly indexProps = [
    { index: 1, label: 'category' },
    { index: 2, label: 'action' },
    { index: 3, label: 'label' },
    { index: 4, label: 'property' },
    { index: 5, label: 'value' },
  ];

  buildDescription(): string {
    const eventLabel = (this.constructor as any).label.replace(' property', '');
    return `${eventLabel} [${this.getPropertyLabel()}] property ${this.getOperatorLabel()} [${this.condition.value}]`;
  }

  private getPropertyLabel(): string {
    const prop = ((this.constructor as any).indexProps as Array<IndexProperty>).find(prop => prop.index === this.condition.options.index);
    return prop ? prop.label : '';
  }
}
